import { render, staticRenderFns } from "./Importacion.vue?vue&type=template&id=59460460&"
import script from "./Importacion.vue?vue&type=script&lang=js&"
export * from "./Importacion.vue?vue&type=script&lang=js&"
import style0 from "./Importacion.vue?vue&type=style&index=0&id=59460460&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports